import React, { Component } from 'react';
import { Button, Table, Segment, Checkbox } from 'semantic-ui-react'
import moment from 'moment';
import 'semantic-ui-css/components/checkbox.min.css';

export default class Transactions extends Component {
  static propTypes = {}

  constructor(props) {
    super(props);
    this.state = {
      toRefund: []
    }
  }

  addToRefund = (transaction) => this.setState({ toRefund: [...this.state.toRefund, transaction] })

  clearToRefund = () => this.setState({ toRefund: [] })

  render() {
    return !this.props.loading ? <Table compact celled style={{marginBottom: '20px'}}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>#</Table.HeaderCell>
            <Table.HeaderCell>Service Name</Table.HeaderCell>
            <Table.HeaderCell>Billed On</Table.HeaderCell>
            <Table.HeaderCell>Amount Billed</Table.HeaderCell>
            <Table.HeaderCell>Unsubscribed On</Table.HeaderCell>
            <Table.HeaderCell>Refunded</Table.HeaderCell>
            <Table.HeaderCell>
              <Checkbox
                slider
                checked={this.state.toRefund.length === this.props.transactions.filter(transaction => !transaction.Status).length}
                disabled={this.props.refunding || this.props.role !== 'manager' || this.props.status !== 'APPROVED'}
                onChange={(e, {checked}) => checked ? this.setState({ toRefund: this.props.transactions.filter(transaction => !transaction.Status) }) : this.setState({ toRefund: []})}
              />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {this.props.transactions.map((transaction, idx) => (
            <Table.Row key={transaction.MtReqId} error={transaction.error}>
              <Table.Cell>{idx + 1}</Table.Cell>
              <Table.Cell>{transaction.SrvcName}</Table.Cell>
              <Table.Cell>{moment(transaction.BilledOn).format('DD-MM-YYYY')}</Table.Cell>
              <Table.Cell>{parseInt(transaction.AmountBilled, 10) / 1000} {this.props.currency.toUpperCase()}</Table.Cell>
              <Table.Cell>{moment(transaction.UnsubscribedOn).format('DD-MM-YYYY')}</Table.Cell>
              <Table.Cell>{transaction.Status ? moment(transaction.RefundedOn).format('DD-MM-YYYY') : 'No'}</Table.Cell>
              <Table.Cell>
                <Checkbox
                  checked={this.state.toRefund.find(refund => refund.MtReqId === transaction.MtReqId) || transaction.Status}
                  slider
                  disabled={transaction.Status || this.props.refunding || this.props.role !== 'manager' || this.props.status !== 'APPROVED'}
                  onChange={(e, {checked}) => checked ? this.addToRefund(transaction) : this.setState({ toRefund: this.state.toRefund.filter(refund => refund.MtReqId !== transaction.MtReqId) })}
                />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell />
            <Table.HeaderCell colSpan='6'>
              <Button
                onClick={() => {
                  this.props.makeRefunds(
                    this.state.toRefund
                      .map(({ ReferenceId, AmountBilled, BilledOn, SrvcId, MtReqId }) => ({ ReferenceId, AmountBilled, BilledOn, SrvcId, MtReqId, Msisdn: this.props.msisdn, OC: this.props.oc, _id: this.props.ticketId }))
                  )
                  this.clearToRefund()
                }}
                loading={this.props.refunding}
                size='small'
                disabled={!this.props.transactions.filter(transaction => !transaction.Status).length || this.props.refunding || this.props.role !== 'manager' || !this.state.toRefund.length}
              >
                Refund {
                  this.state.toRefund
                  .filter(transaction => !transaction.Status)
                  .reduce((acc, transaction) => acc + (parseInt(transaction.AmountBilled, 10) / 1000), 0)
                  .toFixed(2)
                } {this.props.currency.toUpperCase()}
              </Button>
              <h3>Total Refunded: {this.props.transactions.filter(transaction => transaction.Status).reduce((acc, transaction) => acc + (parseInt(transaction.AmountBilled, 10) / 1000), 0)} {this.props.currency.toUpperCase()}</h3>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table> : <Segment loading style={{height: '200px', marginBottom: '20px'}}></Segment>
  }
}



// WEBPACK FOOTER //
// ./src/components/TransactionsComponent/Transactions.js